import type { CameraApiResponse } from "@src/services/api/cameras-api";
import { isLegacyAppCamera } from "./key-parser";

export type StreamingCapability = "jpeg" | "http-mp4";

export function getCameraStreamingCapability(camera: CameraApiResponse): StreamingCapability {
  return isLegacyAppCamera(camera) ? "jpeg" : "http-mp4";
}

export function supportsJpegStream(camera: CameraApiResponse): boolean {
  return getCameraStreamingCapability(camera) === "jpeg";
}

export function supportsMp4Stream(camera: CameraApiResponse): boolean {
  return getCameraStreamingCapability(camera) === "http-mp4";
}
